import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { RESULT_PAYMENT } from 'shared/api/check-payment'
import SuccessImage from 'shared/images/guard-with-key.webp'
import { Button } from 'shared/ui/button'

import { InsuranceError } from './components/insurance-error'
import styles from './styles.module.scss'

type Props = {
  status: RESULT_PAYMENT
}

export const InsuranceSuccess = ({ status }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const goToMyOrders = () => navigate(RoutingPaths.myOrders.path())
  const retryInsurance = () =>
    navigate(RoutingPaths.insurance.application.path(), { replace: true })

  if (status === RESULT_PAYMENT.CANCELLED) {
    return <InsuranceError onRetry={retryInsurance} />
  }

  return (
    <div className={clsx('safe-area-top-padding', styles.container)}>
      <div className={styles.content}>
        <img
          src={SuccessImage}
          className={styles.image}
          alt=""
        />
        <h1 className={clsx(styles.title, 'bold-28')}>
          {t('insurance.vzr.success.title')}
        </h1>
        <p className={clsx(styles.description, 'medium-16')}>
          {t('insurance.vzr.success.description')}
        </p>
        <div className={styles.actions}>
          <Button
            type="button"
            variant="grey"
            className={styles.button}
            onClick={goToMyOrders}
          >
            <span className="bold-16">{t('my_orders')}</span>
          </Button>
        </div>
      </div>
    </div>
  )
}
